import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import GoogleLogin from "../googleLogin/googleLogin";
import {auth} from "../../../firebase";

function Login({setCurrentPage, onFinishLogin}) {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showDisableButton, setShowDisableButton] = useState(false);

    const enableUser = (e) => {
        e.preventDefault();
        dismissError();
    }

    const loginUser = (e) => {
        e.preventDefault();
        dismissError();
        auth.signInWithEmailAndPassword(email, password)
            .then((userCredential) => {
                onFinishLogin();
            })
            .catch((error) => {
                // Handle any errors that occur during sign in
                document.getElementById("loginHomeModal")?.querySelectorAll('input').forEach(x => x.classList.add('is-invalid'))
                if (error.message.includes('auth/user-not-found')) {
                    setError("Usuario no encontrado");
                } else if (error.message.includes('auth/user-disabled')) {
                    setError("Usuario deshabilitado");
                    setShowDisableButton(true);
                } else if (error.message.includes('auth/wrong-password')) {
                    setError("Contraseña incorrecta");
                }
                // Handle the error accordingly
            });
    }

    function dismissError() {
        setError("");
        document.getElementById("loginHomeModal")?.querySelectorAll('input').forEach(x => x.classList.remove('is-invalid'))
    }

    const colSize = "col-12";

    return (
        <div className="col-12">
            <div className="col-12 text-center">
                <GoogleLogin onFinishLogin={onFinishLogin}/>
            </div>
            <div className="d-flex flex-row align-items-center col-12 justify-content-center">
                <hr className="col-4 me-3"/>
                <span className="text-center">O</span>
                <hr className="col-4 ms-3"/>
            </div>
            <form className="d-flex flex-row flex-wrap col-12 justify-content-center">
                {error && <div className="alert alert-danger alert-dismissible fade show col-7" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => dismissError()}/>
                </div>}

                <div className={"form-floating mb-3 " + colSize}>
                    <input value={email} onChange={e => {
                        setEmail(e.target.value);
                        setShowDisableButton(false);
                    }}
                           type="email" className="form-control" id="floatingInput" placeholder="Correo electrónico"/>
                    <label htmlFor="floatingInput">Email</label>
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input value={password} onChange={e => setPassword(e.target.value)}
                           type="password" className="form-control" id="floatingPassword" placeholder="Contraseña"/>
                    <label htmlFor="floatingPassword">Contraseña</label>
                </div>
                <div className={colSize + " mb-3 d-flex flex-row justify-content-between"}>
                    {!showDisableButton && <button className="btn btn-primary" type="submit" onClick={e => {
                        loginUser(e);
                    }}>Iniciar sesión</button>}
                    {showDisableButton && <button className="btn btn-primary" type="submit" onClick={e => {
                        enableUser(e);
                    }}>Habilitar cuenta e iniciar sesión</button>}
                    <a className="link-body-emphasis" style={{cursor: "pointer"}}
                       onClick={() => setCurrentPage("recoverPass")}>¿Olvidaste tu contraseña?</a>
                </div>
                <div className={colSize + " mb-3"}>
                    <b>¿No tienes una cuenta?</b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}}
                       onClick={() => setCurrentPage("signUp")}>Regístrate!</a>
                </div>
            </form>
        </div>
    )
}

export default Login;
